import i18next from 'i18next';

i18next.addResources('en', 'FileInput', {
  previewTitle: 'Actual File Preview'
});
